import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import MuiAlert from '@material-ui/lab/Alert';
import api from '../api';
import CustomTextField from '../components/customTextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import NumberFormat from 'react-number-format';
import CustomDate from '../components/customDate';
import { MuiPickersUtilsProvider, KeyboardTimePicker, validate } from "@material-ui/pickers";
import IcDelete from '../../assets/ic_delete.png';
import IcTambah from '../../assets/ic_add_white.png';
import { format } from 'date-fns';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="Rp. "
        />
    );
}

export default function AddJadwalTelekonsul(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [listDokter, setListDokter] = useState([])
    const [doctor, setDoctor] = useState(null)
    const [durasi, setDurasi] = useState(0)
    const [validFrom, setValidFrom] = React.useState(new Date());
    const listScheduleType = [
        { value: 'Reservasi', id: 1 },
        { value: 'Non Reservasi', id: 2 },
    ]
    const [scheduleType, setScheduleType] = useState(null)
    const [day, setDay] = useState([])
    const listDay = [
        { value: 'Senin', id: 1 },
        { value: 'Selasa', id: 2 },
        { value: 'Rabu', id: 3 },
        { value: 'Kamis', id: 4 },
        { value: 'Jumat', id: 5 },
        { value: 'Sabtu', id: 6 },
        { value: 'Minggu', id: 0 },
    ]
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [reservationTime, setReservationTime] = useState(null);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleConfirm, setVisibleConfirm] = React.useState(false);
    const [jamReservasiLength, setJamReservasiLength] = React.useState([]);

    const [errorDays, setErrorDays] = React.useState(false);
    const [texterrorDays, setTextErrorDays] = React.useState(null);
    const [errorSchedule, setErrorSchedule] = React.useState(false);
    const [texterrorSchedule, setTextErrorSchedule] = React.useState(null);
    const [errorDurasi, setErrorDurasi] = React.useState(false);
    const [texterrorDurasi, setTextErrorDurasi] = React.useState(null);
    const [errorStartTime, setErrorStartTime] = React.useState(false);
    const [texterrorStartTime, setTextErrorStartTime] = React.useState(null);
    const [errorEndTime, setErrorEndTime] = React.useState(false);
    const [texterrorEndTime, setTextErrorEndTime] = React.useState(null);
    const [errorValidFrom, setErrorValidFrom] = React.useState(false);
    const [texterrorValidFrom, setTextErrorValidFrom] = React.useState(null);
    const [errorIndex, setErrorIndex] = React.useState(null);
    const [textErrorIndex, setTextErrorIndex] = React.useState(null);


    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const handleTambah = () => {
        jamReservasiLength.push({
            jam: null,
        })
        forceUpdate()
    }

    const handleHapus = (index) => {
        jamReservasiLength.splice(index, 1)
        forceUpdate()
    }

    const handleJamReservasi = (val, index) => {
        jamReservasiLength[index].jam = val
        forceUpdate()
    }

    useEffect(() => {
        getListDokter()
        console.log(props);
    }, [])

    const getListDokter = () => {
        api.create().getListMasterDokter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data
                        let idx = data.findIndex((val) => val.name === props.selectedData.name)
                        if (idx > 0) {
                            setDoctor(data[idx])
                        }
                        setListDokter(data)
                        forceUpdate()
                    }
                }
            }
        })
    }

    const doSubmit = (e) => {
        console.log(scheduleType, startTime, endTime);
        if (validFrom === null) {
            setErrorValidFrom(true)
            setTextErrorValidFrom("Tanggal Berlaku wajib diisi")
        } else if (scheduleType === null) {
            setErrorSchedule(true)
            setTextErrorSchedule("Tipe Jadwal wajib diisi")
        } else {
            if (scheduleType !== null) {
                if (scheduleType.id === 2) {
                    if (startTime === null) {
                        setErrorStartTime(true)
                        setTextErrorStartTime("Jam Mulai wajib diisi")
                    } else if (endTime === null) {
                        setTextErrorEndTime(true)
                        setTextErrorEndTime("Jam Selesai wajib diisi")
                    } else {
                        let schedule = []
                        schedule.push({
                            "date": format(new Date(validFrom), 'yyyy-MM-dd'),
                            "session": [
                                {
                                    "time_start": format(new Date(startTime), 'HH:mm'),
                                    "time_end": format(new Date(endTime), 'HH:mm'),
                                }
                            ]
                        })
                        let payload = {
                            "doctor_telemedicine_id": doctor.id,
                            "type": scheduleType.id,
                            "schedule": schedule
                        }
                        console.log(JSON.stringify(payload));
                        props.createJadwal(payload)
                    }
                } else {
                    if (durasi === "") {
                        setErrorDurasi(true)
                        setTextErrorDurasi("Durasi wajib diisi")
                    } else if (jamReservasiLength.length === 0) {
                        setOpenAlert(true)
                        setMessageAlert("Tambahkan Jam Reservasi")
                        setStatusAlert('warning')
                    } else {
                        let session = []
                        if (jamReservasiLength.length > 0) {
                            let index = jamReservasiLength.findIndex((val) => val.jam === null)
                            if (index > -1) {
                                // setOpenAlert(true)
                                // setMessageAlert("Jam Reservasi wajib diisi")
                                // setStatusAlert('warning')
                                setErrorIndex(index)
                                setTextErrorIndex("Jam Reservasi wajib diisi")
                            } else {
                                jamReservasiLength.map((item) => {
                                    session.push({
                                        "time_reservation": format(new Date(item.jam), 'HH:mm')
                                    })
                                })
                            }
                        }
                        let schedule = []
                        schedule.push({
                            "date": format(new Date(validFrom), 'yyyy-MM-dd'),
                            "time": Number(durasi),
                            "session": session
                        })
                        let payload = {
                            "doctor_telemedicine_id": doctor.id,
                            "type": scheduleType.id,
                            "schedule": schedule
                        }
                        console.log(payload);
                        if (session.length > 0) {
                            props.createJadwal(payload)
                        }

                    }
                }
            }

        }
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Master Jadwal</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: scheduleType && scheduleType.id === 1 ? '20px 50px 0px' : '20px 50px' }}>
                    <div className="column-1">
                        <div style={{ margin: 0 }}>
                            <Autocomplete
                                options={listDokter}
                                disabled
                                getOptionLabel={(option) => option.name}
                                style={{ width: '100%' }}
                                onChange={(event, newInputValue) => {
                                    setDoctor(newInputValue)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label={'Nama Dokter'}
                                    />
                                }
                                value={doctor}
                            />
                        </div>
                    </div>
                    <div className="column-2">
                        <div>
                            <div style={{ marginTop: '-16px' }}>
                                <CustomDate
                                    required={true}
                                    error={errorValidFrom}
                                    helperText={texterrorValidFrom}
                                    value={validFrom}
                                    label="Tanggal Berlaku"
                                    minDate={new Date()}
                                    setValue={(date) => {
                                        setValidFrom(date)
                                        setErrorValidFrom(false)
                                        setTextErrorValidFrom(null)
                                        forceUpdate()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="column-1">
                        <div style={{ margin: 0 }}>
                            <Autocomplete
                                options={listScheduleType}
                                getOptionLabel={(option) => option.value}
                                style={{ width: '100%' }}
                                onChange={(event, newInputValue) => {
                                    setScheduleType(newInputValue)
                                    setErrorSchedule(false)
                                    setTextErrorSchedule(null)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        required={true}
                                        error={errorSchedule}
                                        helperText={texterrorSchedule}
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label={'Tipe Jadwal'}
                                    />
                                }
                                value={scheduleType}
                            />
                        </div>
                    </div>
                    {/* <div className="column-2">
                        <div style={{ margin: 0 }}>
                            <Autocomplete
                                multiple
                                size='small'
                                options={listDay}
                                getOptionLabel={(option) => option.value}
                                style={{ width: '100%' }}
                                onChange={(event, newInputValue) => {
                                    setDay(newInputValue)
                                    setErrorDays(false)
                                    setTextErrorDays(null)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        required={true}
                                        error={errorDays}
                                        helperText={texterrorDays}
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label={' Hari'}
                                    />
                                }
                                value={day}
                            />
                        </div>
                    </div> */}

                    {scheduleType &&
                        scheduleType.id === 2 && (
                            <div className="column-2">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        required={true}
                                        error={errorStartTime}
                                        helperText={texterrorStartTime}
                                        ampm={false}
                                        label="Jam Mulai"
                                        value={startTime}
                                        onChange={(date) => {
                                            setStartTime(date)
                                            setErrorStartTime(false)
                                            setTextErrorStartTime(null)
                                        }}
                                        style={{ width: '100%' }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    />
                                </MuiPickersUtilsProvider>
                                {/* <div style={{ marginTop: 10 }}>
                                    <CustomTextField
                                        label="Durasi"
                                        type={"number"}
                                        onChange={(e) => setDurasi(e)}
                                    />
                                </div> */}
                            </div>
                        )}

                    {scheduleType &&
                        scheduleType.id === 2 && (
                            <div className="column-1">
                                <div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            required={true}
                                            error={errorEndTime}
                                            helperText={texterrorEndTime}
                                            ampm={false}
                                            label="Jam Selesai"
                                            value={endTime}
                                            onChange={(date) => {
                                                setEndTime(date)
                                                setErrorEndTime(false)
                                                setTextErrorEndTime(null)
                                            }}
                                            style={{ width: '100%' }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                        )}
                </div>
                {scheduleType &&
                    scheduleType.id === 1 && (
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '0px 50px 20px' }}>
                            <div className="column-1" style={{ marginTop: 10, textAlign: 'left' }}>
                                <CustomTextField
                                    required={true}
                                    error={errorDurasi}
                                    helperText={texterrorDurasi}
                                    label="Durasi"
                                    type={"number"}
                                    onChange={(e) => {
                                        setDurasi(e)
                                        setErrorDurasi(false)
                                        setTextErrorDurasi(null)
                                    }}
                                />
                                <button style={{ outline: 'none', backgroundColor: 'transparent', borderColor: 'transparent', cursor: 'pointer', marginTop: 10, padding: 0 }}
                                    onClick={() => handleTambah()}
                                >
                                    <Typography style={{ fontWeight: '500', color: '#0066ff' }}>+ Tambah Jam Reservasi</Typography>
                                </button>
                            </div>

                            {jamReservasiLength && jamReservasiLength.map((item, index) => (
                                <div className={index % 2 === 0 ? "column-1" : "column-2"}>
                                    <div style={{ display: 'flex', marginTop: index === 0 || index === 1 ? 0 : 10 }}>
                                        <div className="">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardTimePicker
                                                    required={true}
                                                    error={errorIndex === index ? true : false}
                                                    helperText={errorIndex === index ? textErrorIndex : ""}
                                                    ampm={false}
                                                    label="Jam Reservasi"
                                                    value={item.jam}
                                                    onChange={(e) => {
                                                        handleJamReservasi(e, index)
                                                        setErrorIndex(null)
                                                        setTextErrorIndex(null)
                                                    }}
                                                    style={{ width: '100%' }}
                                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-circle btn-white"
                                            style={{ borderColor: 'transparent', outline: 'none', marginTop: 10, padding: 5 }}
                                            onClick={() => handleHapus(index)}
                                        >
                                            <div style={{ width: 24, height: 24, backgroundColor: '#278863', borderRadius: 15 }}>
                                                <img src={IcDelete} style={{ width: 12, height: 12 }} />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            ))}

                            {/* <div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            ampm={false}
                                            label="Jam Reservasi"
                                            value={reservationTime}
                                            onChange={setReservationTime}
                                            style={{ width: '100%' }}
                                            InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div> */}
                        </div>
                    )}
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {visibleConfirm && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleConfirm(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Reservasi yang sudah terbuat dari jadwal tersebut akan dibatalkan secara otomatis. Apakah anda ingin melanjutkan pembuatan jadwal libur nasional?</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleConfirm(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => null}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }
        </div>
    )
}